import { RawButton, Text } from '@outdoorsyco/bonfire';
import { clsx } from 'clsx';
import Image, { StaticImageData } from 'next/image';
import React from 'react';

import { MapboxStyle } from '@/services/types/map';

interface IProps {
  isActive: boolean;
  imageUrl: string | StaticImageData;
  imageAlt: string;
  imageWidth: number;
  buttonText: string;
  mapStyle: MapboxStyle;
  setMapboxStyle: (styleType: MapboxStyle) => void;
}

export const MapLayerButton: React.FC<IProps> = ({
  isActive,
  imageUrl,
  imageAlt,
  imageWidth,
  buttonText,
  mapStyle,
  setMapboxStyle,
}) => {
  return (
    <div className="relative overflow-hidden">
      <RawButton className="block" onPressEnd={() => setMapboxStyle(mapStyle)}>
        <Image
          className={clsx('rounded-xl !border-2 !border-solid', {
            '!border-green-500': isActive,
            '!border-transparent': !isActive,
          })}
          src={imageUrl}
          alt={imageAlt}
          width={imageWidth}
          height="84"
        />

        <Text className="mt-2">{buttonText}</Text>
      </RawButton>
    </div>
  );
};
